import { render, staticRenderFns } from "./CreateMajority.vue?vue&type=template&id=82a0c442&"
import script from "./CreateMajority.vue?vue&type=script&lang=js&"
export * from "./CreateMajority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports